<template>
  <div>
    <Header :isLogin="!!getUserToken()" from="membership" class="fixed left-0 top-0" />

    <div style="padding-top:64px;">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
  import Header from '@c/Header.vue'
  import 'lazysizes'
  import { userInfo, userThirdInfo } from "@a/account";
  import { getUserToken } from "@u/helpers/auth"

  // 提供父组件 变量 和 指定方法
  const browserGo = () => {
    location.pathname === '/' && window.history.go(-1)
  }

  onMounted(() => {
    // 监听浏览器返回
    window.addEventListener('popstate', browserGo, false)
  });

  onUnmounted(() => {
    window.removeEventListener('popstate', browserGo, false)
  })
</script>
